/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.recommendations.rpc.ranked.RankedRecommendationService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './RankedRecommendationService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.recommendations.rpc.ranked.RankedRecommendationService#getRecommendations
 */
export const GET_RECOMMENDATIONS_QUERY_FIELD_NAME = 'com_hubspot_academy_recommendations_rpc_ranked_RankedRecommendationService_getRecommendations';
export const GET_RECOMMENDATIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_RECOMMENDATIONS_QUERY_FIELD_NAME,
  args: ['language', 'size', 'inferenceSource', 'types', 'scoreAllOptions'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getRecommendationsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.recommendations.rpc.ranked.RankedRecommendationService#registerFeedback
 */
export const REGISTER_FEEDBACK_MUTATION_FIELD_NAME = 'com_hubspot_academy_recommendations_rpc_ranked_RankedRecommendationService_registerFeedback';
export const REGISTER_FEEDBACK_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REGISTER_FEEDBACK_MUTATION_FIELD_NAME,
  args: ['correlationId', 'options'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.registerFeedbackRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.recommendations.rpc.ranked.RankedRecommendationService#registerContentEngagement
 */
export const REGISTER_CONTENT_ENGAGEMENT_MUTATION_FIELD_NAME = 'com_hubspot_academy_recommendations_rpc_ranked_RankedRecommendationService_registerContentEngagement';
export const REGISTER_CONTENT_ENGAGEMENT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REGISTER_CONTENT_ENGAGEMENT_MUTATION_FIELD_NAME,
  args: ['resultId', 'contentContainerType', 'engagedContentId', 'correlationId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.registerContentEngagementRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});